

import React, { useCallback, useEffect, useState } from 'react'
import { Button, Upload, Form, message, Alert, Spin } from 'antd';
import ChatMessage from './chartMessages';
import FloatInput from 'src/utils/floatingLabelInput';
import apis from './apiCalls';
import { uuidv4 } from 'src/utils/constantsErrMsgs';
import { connect, useSelector } from 'react-redux';
import apiCalls from 'src/api/apiCalls';
import { validateContentRules } from 'src/utils/custom.validator';
import { devlopConfigAPi } from 'src/api';
import NoData from '../shared/noDataComponent';
const CollapseData = (props) => {
    const [form] = Form.useForm();
    const [uploadError, setUploadError] = useState();
    const [fileLists, setFileLists] = useState({ SignImage: [] });
    const [inputText, setInputText] = useState('');
    const [docRepository, setDocRepository] = useState(props.docRepository || []);
    const [loading, setLoading] = useState({ approve: false, reject: false });
    const [documentUploading, setDocumentUploading] = useState(false);
    const [selectedFilesList, setSelectedFilesList] = useState([])
    const user = useSelector(state => state.oidc?.user.currentUser)
    useEffect(() => {
        if (Array.isArray(props.docRepository) && props.docRepository.length > 0) {
            setDocRepository(props.docRepository);
        }
    }, [props.docRepository]);
    const handleCustomRequest = useCallback(async ({ file }) => {
        const actualFile = file.originFileObj;
        const formData = new FormData();
        setLoading(true);
        formData.append("file", actualFile, actualFile.name);
        try {
            const response = await devlopConfigAPi.post(
                `/CaseManagement/CasesUploadFile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response?.ok) {
                const uploadedFile = {
                    id: response.data.id,
                    fileName: response.data.fileName,
                    fileSize: response.data.fileSize,
                    state: "submitted",
                };
                setSelectedFilesList((prevList) => [...prevList, uploadedFile]);
                setFileLists((prevFileLists) => ({
                    ...prevFileLists,
                    uploadedFile,
                }));
                message.success("Upload successful!");
            } else {
                message.error("Upload response is invalid.");
            }
        } catch (error) {
            message.error("File upload failed.");
        } finally {
            setDocumentUploading(false);
        }
    }, [devlopConfigAPi]);

    const handleUploadChange = useCallback(({ file, fileList }) => {
        setUploadError(null);
        const MAX_FILE_SIZE = 2 * 1024 * 1024;
        const allowedExtensions = [".png", ".jpeg", ".jpg", ".JPG", ".JPEG", ".PNG", ".pdf", ".PDF"];
        const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
        if (file.size > MAX_FILE_SIZE) {
            setUploadError("File size cannot exceed 2MB.");
            return;
        }
        if (!allowedExtensions.includes(fileExtension)) {
            setUploadError("Only .png, .jpeg, .jpg, and .pdf files are allowed.");
            return;
        }
        const fileNameParts = file.name.split(".");
        if (fileNameParts?.length > 2) {
            setUploadError("Files with double extensions are not allowed.");
            return;
        }
        setFileLists((prevFileLists) => ({ ...prevFileLists, fileList }));
        if (file.status === "uploading") {
            setDocumentUploading(true);
            handleCustomRequest({ file });
        }
        if (file.status === "done") {
            handleCustomRequest({ file });
        }
        if (file.status === "error") {
            setDocumentUploading(false);
            setUploadError("Upload failed.");
        }
    }, [handleCustomRequest]);

    const handleRemove = useCallback((id) => {
        setSelectedFilesList((prevList) => prevList.filter((file) => file.id !== id));
        setUploadError(null);
    }, []);

    const handleAddMessage = useCallback(async (e, status) => {
        e.preventDefault();
        setUploadError(null);
        try {
            await form.validateFields();
            setLoading({ approve: status === 'Approved', reject: status === 'Rejected' });
    
            if (inputText.trim() && fileLists.SignImage.length) {
                setUploadError('Please add a message or upload a file.');
                setLoading({ approve: false, reject: false });
                return;
            }
    
            const messageObj = {
                id: uuidv4(),
                docunetDetailId: props?.docunetDetailId,
                docRepositories: selectedFilesList,
                reply: inputText,
                repliedBy: user?.userName,
                repliedDate: new Date().toISOString(),
                isCustomer: true,
                path: null,
                status: null,
                customerId: props?.caseData?.customerId,
                caseId: props?.caseData?.id,
                info: null,
            };
    
            try {
                const response = await apis.approveDoc(messageObj);
                if (response.ok) {
                    const newMessage = {
                        id: uuidv4(),
                        reply: inputText,
                        repliedBy: user?.userName || 'Admin',
                        repliedDate: new Date().toISOString(),
                        isCustomer: true,
                        docRepositories: selectedFilesList,
                        status,
                    };
    
                    setDocRepository((prev) => [...prev, newMessage]);
                    message.success('Message successfully sent!');
                } else {
                    setUploadError('Error in sending message!');
                }
    
                setSelectedFilesList([]);
                form.resetFields();
                setInputText('');
                setFileLists({ SignImage: [] });
    
            } catch (error) {
                setUploadError(apiCalls.isErrorDispaly('Error occurred while sending the message!'));
            }
        } catch (error) {
            setLoading({ approve: false, reject: false });
        } finally {
            setLoading({ approve: false, reject: false });
        }
    }, [
        form,
        inputText,
        fileLists,
        selectedFilesList,
        user,
        props
    ]);
    
    const handleKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            setInputText(e.target.value);
            e.preventDefault();
            handleAddMessage(e, 'Approved')
        }
    }, [handleAddMessage])
    const handleInputChange = useCallback((e) => {
        setInputText(e.target.value);
    }, [])
    const closeUploadError = useCallback(() => {
        setUploadError(null)
    }, [])
    const handleCancelMessage = useCallback(() => {
        setInputText("")
        setSelectedFilesList([])
        form.resetFields()
    },[form])
    // Add this inside your component
const handleSubmitClick = useCallback((e) => handleAddMessage(e, "Submit"), [handleAddMessage]);

    return (<>
        {uploadError && (
            <Alert
                type="error"
                description={uploadError}
                onClose={closeUploadError}
                showIcon
                closable message="" className='mb-2' />
        )}
        <div className='admin-chat-msg'>
            {docRepository?.map((message) => (
                <ChatMessage key={message?.id} message={message} caseData={props?.caseData} />
            ))}
            {(props?.caseData?.state == 'Approved' && docRepository?.length == 0) && <NoData />}
            {(props?.caseData?.state !== 'Approved' && props?.caseData?.state !== 'Rejected') &&
                <>
                    <div className='flex items-start gap-2 mt-8 mb-4'>
                        <div className='w-full flex items-center relative'>
                            <div className='!w-full collapsInput items-center upload-chat'>
                                <Form form={form}>
                                    <Form.Item name={"SignImage"}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Is required',
                                            },
                                            {
                                                whitespace: true,
                                                message: "Is required",
                                            },
                                            {
                                                validator: validateContentRules,
                                            },
                                        ]}>
                                        <div>
                                            <div className='flex items-center chat-input-field !relative border border-StrokeColor rounded-5'>
                                                <FloatInput
                                                    className="cust-input w-full"
                                                    label="Send Message"
                                                    placeholder="Send Message"
                                                    maxLength={200}
                                                    style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                                    onChange={handleInputChange}
                                                    onKeyDown={!loading.approve ? handleKeyPress : null}
                                                    value={inputText}
                                                    disabled={loading.approve}
                                                    required
                                                />

                                                <Upload    
                                                    className=""
                                                    multiple={true}
                                                    accept=".png,.jpg,.jpeg,application/pdf"
                                                    maxCount={1}
                                                    showUploadList={false}
                                                    onChange={handleUploadChange}
                                                    fileList={fileLists.SignImage}
                                                    onRemove={handleRemove}
                                                >
                                                    <div className='flex items-center p-2'>
                                                        <span className='icon attech-icon cursor-pointer'></span>
                                                    </div>
                                                </Upload>
                                            </div>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </div>

                        </div>
                        <div>
                            <h6 className='bg-primaryColor rounded-md w-[40px] h-[40px] flex items-center justify-center'><span className='text-lightDark text-base'>{user?.userName?.charAt(0)?.toUpperCase()}</span></h6>
                        </div>
                    </div>
                    {documentUploading && <Spin spinning={documentUploading}></Spin>}
                    <div className="grid xl:grid-cols-2 md:grid-cols-1 gap-2">
                        {selectedFilesList.length > 0 ? (
                            selectedFilesList.map((file, index) => (
                                <div
                                    className="ant-upload-list-item flex gap-2 items-center justify-between border border-StrokeColor rounded-5 p-2"
                                    key={file.id || index}
                                >
                                    <div
                                        className="flex gap-2 items-center cursor-pointer"
                                    >
                                        <span className="icon attech-icon"></span>
                                        <p className="truncate xl:w-40  w-48 text-ellipsis">{file?.fileName}</p>
                                    </div>
                                    <span
                                        className="icon deleterow-icon cursor-pointer"
                                        onClick={() => handleRemove(file?.id)}
                                    ></span>
                                </div>
                            ))
                        ) : (
                            <p className="text-center col-span-2"></p>
                        )}
                    </div>
                </>
            }
        </div>
        {(props?.caseData?.state !== 'Approved' && props?.caseData?.state !== 'Rejected') && <div className='mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
            <Button
                key="back"
                type="cancel"
                className='cancel-btn'
                loading={loading.reject}
                disabled={loading.reject || loading.approve || documentUploading}
                onClick={handleCancelMessage}
            >
                Cancel
            </Button>
            <Button
                key="submit"
                type="primary"
                className='primary-btn'
                loading={loading.approve}
                disabled={loading.approve || loading.reject || documentUploading || props?.state === 'Approved'}
                onClick={handleSubmitClick}
            >
                Submit
            </Button>
        </div>}
    </>)
}

const connectStateToProps = ({ oidc }) => {
    return { user: oidc?.user }
}
export default connect(connectStateToProps)(CollapseData);
